import { TsColorUtils } from 'tsui/utils/ts-color.utils';

export namespace CommonTableStylingFunctions {
  export function applyConditionalStyling(params: any): Record<string, any> {
    const colField = params.colDef?.field;

    if (!colField) return;

    const style = params.data?.meta?.[colField]?.conditional_styling;

    if (!style) return;

    return TsColorUtils.applyConditionalStyling(style?.color, style?.is_bold);
  }
}
